<header soq-app-header></header>
<main class="app-main">
  <router-outlet />
</main>
<footer soq-app-footer></footer>
<procure-loading-indicator
  delay="long"
  [active]="isLoading"
/>
